module.exports = __webpack_public_path__ + "img/f_25_09.c0fd05b4.jpg";